type OnLoad = (image: HTMLImageElement) => void;
type OnError = () => void;

function loadImage(src: string, onLoad: OnLoad, onError: OnError) {
  let image = new Image();
  let removeListeners = () => {
    image.removeEventListener('load', onLoadHandler);
    image.removeEventListener('error', onErrorHandler);
  };
  let onLoadHandler = () => {
    removeListeners();
    onLoad(image);
  };
  let onErrorHandler = () => {
    removeListeners();
    onError();
  };
  image.addEventListener('load', onLoadHandler);
  image.addEventListener('error', onErrorHandler);
  image.src = src;
  return {
    unsubscribe: removeListeners,
  };
}

export default loadImage;
